import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

import { CookieConsentBanner } from '../legal/CookieConsentBanner';
import { ThemeProvider, useTheme } from '../../store/ThemeContext';
import { cn } from '../../utils/cn';

function RootLayoutChrome() {
  const { resolvedTheme } = useTheme();

  return (
    <>
      <Outlet />
      <Toaster
        position="top-center"
        theme={resolvedTheme}
        toastOptions={{
          className: 'font-body',
          classNames: {
            toast: cn(
              'border shadow-2xl rounded-ds-md',
              '[&[data-tone="success"]]:bg-success-tint',
              '[&[data-tone="warning"]]:bg-warning-tint',
              '[&[data-tone="error"]]:bg-danger-tint',
              '[&[data-tone="info"]]:bg-info-tint',
            ),
            title: 'text-type-body font-semibold',
            description: 'text-type-body-sm text-muted-foreground',
            actionButton:
              '!bg-sage-500 text-white hover:!bg-sage-600 rounded-ds-md px-space-3 py-space-1',
            cancelButton:
              '!bg-transparent border border-border text-muted-foreground rounded-ds-md px-space-3 py-space-1',
          },
        }}
      />
      <CookieConsentBanner />
    </>
  );
}

/**
 * Root shell inside RouterProvider — global UI that needs router context.
 */
export function RootLayout() {
  return (
    <ThemeProvider>
      <RootLayoutChrome />
    </ThemeProvider>
  );
}
